import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

const NotFoundPage = lazy(() => import('./not-found/not-found.page'));
const UnavailablePage = lazy(
  () => import('./page-unavailable/page-unavailable.page'),
);

const UnauthorizedPage = lazy(
  () => import('./unauthorized-page/unauthorized.page'),
);

export const CoreRoutes = () => {
  return (
    <Routes>
      <Route path="403" element={<UnavailablePage />} />
      <Route path="unauthorized" element={<UnauthorizedPage />} />
      <Route path="404" element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
